import { DnsAttemptOutcome } from "@redotech/crdb-enums/dns/dns-attempt-outcome";
import { DnsFailureClass } from "@redotech/crdb-enums/dns/dns-failure-class";
import * as z from "zod";

/**
 * The provisioner's answer. Succeeded makes its records read pending, never
 * resolved — only a sweep promotes one. A second answer is ignored.
 */
export const settleDnsAttempt = {
  name: "settleDnsAttempt" as const,
  input: z.object({
    /** The attempt is the domain's own open one, so no id crosses the wire. */
    domain: z.string(),
    /** Started is not settleable, so it is absent here. */
    outcome: z.union([
      z.literal(DnsAttemptOutcome.Succeeded),
      z.literal(DnsAttemptOutcome.Failed),
      z.literal(DnsAttemptOutcome.Abandoned),
    ]),
    /** Required for failed: the class decides the merchant's next step. */
    failure: z
      .object({
        class: z.enum(DnsFailureClass),
        code: z.string(),
        message: z.string(),
        /** What it refused, when a provisioner names one. */
        capability: z
          .union([z.literal("automation"), z.literal("delegation")])
          .optional(),
      })
      .optional(),
  }),
  output: z.null(),
};
